import React, { useRef, useImperativeHandle } from "react";
import api from "../../utils/api";
import config from "../../temp/config";
import { injectScript } from "../../utils";
import { getCulture } from "../../utils/siteUtils";
import "./style.scss";
const containerId = `arvato-${Math.random()
  .toString(16)
  .toString(16)
  .substr(2)}`;
const ArvatoWidget = React.forwardRef(({ arvatoOptions, sepa, label, amount, user, visible, onSubmit, onError, onRenderSuccess }, ref) => {
  const { scriptUrl, tokenizationServiceUrl, cssUrl, mandateConfirmationText, paymentMethods } = arvatoOptions;
  const arv = useRef();
  const callbackResponsed = useRef(false);
  useImperativeHandle(ref, () => ({
    async init() {
      if (!arv.current) {
        if (!global.Arvato) {
          await injectScript(scriptUrl.value);
        }
        await initArvato();
      }
    },
    submit() {
      arv.current.tokenize();
    }
  }));
  const initArvato = async () => {
    const {
      obj: { securityToken, countryCode, currencyCode }
    } = await api.order.payment.init();
    setTimeout(() => {
      const culture = getCulture();
      const arvatoOptions = new global.Arvato.PayNext.WidgetApiOptions();
      arvatoOptions.tokenizationServiceUrl = tokenizationServiceUrl.value;
      arvatoOptions.securityToken = securityToken;
      arvatoOptions.placeHolder = containerId;
      arvatoOptions.countryCode = countryCode; //"NL";
      arvatoOptions.currencyCode = currencyCode; //"EUR";
      arvatoOptions.culture = culture; //"nl-NL";
      if (cssUrl.value) {
        let cssLink = cssUrl.value;
        if (!/^http?s/.test(cssLink)) {
          cssLink = `${config.sitecoreApiHost}${cssLink}`;
        }
        arvatoOptions.cssUrl = cssLink;
      }
      arvatoOptions.displayValidationErrors = true;
      arvatoOptions.paymentMethods = paymentMethods.length > 0 ? paymentMethods.map(pm => pm.fields.phrase.value).join(",") : "*";
      arvatoOptions.mandateConfirmationText = mandateConfirmationText?.value || "";
      arvatoOptions.clearFrameAfterSuccessfulPayment = false;
      arvatoOptions.successCallback = successCallback;
      arvatoOptions.errorCallback = errorCallback;
      arvatoOptions.frameWidth = 600;
      arvatoOptions.frameHeight = 360;
      arvatoOptions.renderErrorCallback = renderErrorCallback;
      arvatoOptions.unifiedPaymentMethodLogos = true;
      arvatoOptions.enforcePaymentMethodsOrder = true;
      //optional
      arvatoOptions.firstName = user?.firstName;
      arvatoOptions.lastName = user?.lastName;
      arvatoOptions.amount = amount;

      //todo = not implemented yet
      // arvatoOptions.timeOut = 3000;
      // arvatoOptions.showCVCHint = false;
      // arvatoOptions.busyIndicator = "";
      if (onRenderSuccess) {
        arvatoOptions.renderSuccessCallback = onRenderSuccess;
      }
      arvatoOptions.onWidgetContentResized = resizeCallback; // this will be executed after the widget sends a resize notification
      arvatoOptions.automaticParentResize = true; //when widget content size is changed
      arvatoOptions.mandateConfirmationText = "";
      if (sepa) {
        arvatoOptions.mandateConfirmationText = mandateConfirmationText.value;
      }
      // arvatoOptions.DisableIntroductionText = true;
      arv.current = new global.Arvato.PayNext.WidgetApi(arvatoOptions);
      arv.current.render();
    }, 10);
  };
  const successCallback = response => {
    if (!callbackResponsed.current) {
      if (onSubmit) {
        callbackResponsed.current = true;
        const res = onSubmit(response.PaymentToken);
        if (res instanceof Promise) {
          res.then(() => {
            callbackResponsed.current = false;
          });
        } else {
          callbackResponsed.current = false;
        }
      }
    }
  };
  const errorCallback = res => {
    onError && onError(res);
    console.log("error", res);
  };
  const renderErrorCallback = res => {
    console.log("renderError", res);
  };
  const resizeCallback = () => {};
  return (
    <div className="arvato-widget" style={{ display: visible ? "block" : "none" }}>
      {label && (
        <div className="label-container">
          <span className="label">{label}</span>
        </div>
      )}
      <div id={containerId} className="arvato-container" />
    </div>
  );
});
ArvatoWidget.displayName = "ArvatoWidget";
export default ArvatoWidget;
